'use client';

import type { APlusQuery, PriceCurrency } from '@packages/gql/generated/shopping/graphql';

import { useSetAtom } from 'jotai';
import { useIntl } from 'react-intl';

import { selectedServices } from '@packages/modules/src/atoms';
import { APlus } from '@packages/modules/src/APlus/APlus';
import type { APlusData, APlusItems } from '@packages/modules/src/APlus/types';
import { TipBadge } from '../TipBadge/TipBadge.client';

type ListItemsProps = {
  data: APlusQuery['aplus'];
  currency: PriceCurrency;
};

export const ListItems = ({ data, currency }: ListItemsProps) => {
  const { formatMessage } = useIntl();
  const setAtomSelected = useSetAtom(selectedServices);

  if (!data || !data.clusters || data.clusters.length === 0) return null;

  const servicesData: APlusItems = [];

  data.clusters.forEach((cluster) => {
    if (cluster != null) {
      cluster.services.forEach((service) => {
        servicesData.push({
          uuid: service.uuid,
          name: service.name,
          price: service.price,
          serviceIcon: service.serviceIcon,
          serviceLayerId: service.serviceLayerId,
          clusterLabel: cluster.label,
          free: !!service.gratis,
          preselected: service.preselected,
          mandatory: service.mandatory,
        });
      });
    }
  });

  if (servicesData.length === 0) {
    return null;
  }

  const handleAtom = (atomData: APlusData) => {
    setAtomSelected(atomData);
  };

  return (
    <div className="flex flex-col gap-1.5">
      <header className="flex flex-row items-center gap-1.5">
        <TipBadge />
        <div className="text-size-body-base">
          {formatMessage({
            id: 'productAplus.listItem.headline',
            defaultMessage: 'Jetzt dazubestellen',
          })}
        </div>
      </header>
      <APlus
        items={servicesData}
        onChangeHandler={handleAtom}
        triggerOnChangeHandlerOnInit
        currency={currency}
        layout="ListItems"
      />
    </div>
  );
};
